// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "c36f3faa" + "." + "ae4018595ce7ab83" + ".js";
};